// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import vueMoment from 'vue-moment'
import router from './router'
import VueRouter from 'vue-router'
import App from './App'
import { sync } from 'vuex-router-sync'
import store from '@/store/store'

Vue.use(BootstrapVue)
Vue.use(vueMoment)
Vue.use(VueRouter)

window.$ = require('jquery')
window.JQuery = require('jquery')

sync(store, router)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js